import { AxiosResponse } from 'axios';
import { catchNetworkExceptions } from 'utils/exception';
import { mapNetworkStatuses } from 'utils/exception/mapNetworkStatuses';

import { Codeowners } from 'components/Common/Error/Codeowners';
import { JobDataResponse } from 'components/Job/Types/JobAndEstimateDetails';

import RestAPI from '../../components/Common/restApi';

import {
  AssignJobApiPayload,
  AssignJobApiResponse,
  CopyJobApiPayload,
  CreateJobApiPayload,
  CreateJobApiResponse,
  ScheduleJobApiPayload,
  ScheduleJobApiResponse,
} from './types';

export default class JobApi {
  static show(id: string) {
    return RestAPI.get<{ job: JobDataResponse }>(`/pro/jobs/react/${id}/data`);
  }

  static index(params = {}, headers = {}) {
    return RestAPI.getWithQueryString('/alpha/jobs', params, {
      'HCP-Version': '2020-01-21',
      ...headers,
    });
  }

  static showJobsAssociatedToEquipment(equipmentId: string) {
    return JobApi.index({ equipment: equipmentId, page_size: 50 });
  }

  static create(params: CreateJobApiPayload): Promise<AxiosResponse<CreateJobApiResponse>> {
    return RestAPI.postWithFormData('/alpha/jobs', params);
  }

  static export(params: unknown) {
    return RestAPI.postWithFormData('/alpha/jobs/export', params);
  }

  static schedule(id: string, params: ScheduleJobApiPayload) {
    return catchNetworkExceptions(
      () =>
        RestAPI.updateWithFormData<ScheduleJobApiResponse, ScheduleJobApiPayload>(`/alpha/jobs/${id}/schedule`, params),
      Codeowners.SCHEDULING,
      mapNetworkStatuses
    );
  }

  static assign(id: string, params: AssignJobApiPayload) {
    return catchNetworkExceptions(
      () => RestAPI.updateWithFormData<AssignJobApiResponse, AssignJobApiPayload>(`/alpha/jobs/${id}/assign`, params),
      Codeowners.SCHEDULING,
      mapNetworkStatuses
    );
  }

  static invoice(uuid: string) {
    return RestAPI.postWithFormData(`/alpha/jobs/${uuid}/invoice`, {});
  }

  static updateTax(uuid: string, params: unknown) {
    return RestAPI.updateWithFormData(`/alpha/jobs/${uuid}/tax`, params);
  }

  static updateTags(uuid: string, params: unknown) {
    return RestAPI.updateWithFormData(`/alpha/jobs/${uuid}/tags`, params);
  }

  static updateOrganizationDefaultArrivalWindow(params: unknown) {
    return RestAPI.updateWithFormData('/alpha/organization/default_arrival_window', params);
  }

  static addAttachments(uuid: string, formData: unknown) {
    return RestAPI.postWithFormData(`/alpha/jobs/${uuid}/attachments/bulk_upload`, formData);
  }

  static copyToJob(uuid: string, params: CopyJobApiPayload) {
    return RestAPI.postWithFormData<{ id: string }, CopyJobApiPayload>(`/alpha/jobs/${uuid}/copy_job`, params);
  }
}
